


import React, { Component } from 'react'
import score from 'src/helper/score'
import lang from '../lang'
import langM from '../lang'
import './index.less'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let { language, lang, mycuntry  } = this.props
     console.log(mycuntry.countryId)
    // this 用户
    let rankList = this.props.userRankList || []
    // let rankList = [1,2,3,4,5,5,6,7,8,2,2]
    // last 用户
    let lastUserRankList = this.props.lastUserRankList || []

    // this 我的
    let thisMyUserRank = this.props.thisMyUserRank
    // last 我的
    let lastMyUserRank = this.props.lastMyUserRank

    let heightTotalThis = () => {
      if (rankList.length <= 3) {
        return '8rem'
      } else if (rankList.length > 3) {
        return '100%'
      }
    }
    let heightTotalLast = () => {
      if (lastUserRankList.length <= 3) {
        return '8rem'
      } else if (lastUserRankList.length > 3) {
        return '100%'
      }
    }

    return (
      <div style={{ display: this.props.selectState === '1' ? 'block' : 'none' }}>
        {/* ThisWeek */}
        <div style={{ display: this.props.selectStateChild === '1' ? 'block' : 'none' }}>
          {/* rankings-part */}
          <div className="rank-wrap" style={{
            height: `${heightTotalThis()}`,
          }}>
            {/* title */}
            <div className="rank-title">{lang.points}</div>
            {/* 1 */}

            <div className="one-wrap">
              <div className="one-avatar">
                {mycuntry.countryId ==39 && <div className="test-tur" onClick={jumpToUser.bind(this, rankList && rankList.length > 0 && rankList[0].uid)} ></div>}
                {mycuntry.countryId ==17 && <div className="ksa" onClick={jumpToUser.bind(this, rankList && rankList.length > 0 && rankList[0].uid)} ></div>}
                {mycuntry.countryId !=17 && mycuntry.countryId !=39 && <div className="one-box" onClick={jumpToUser.bind(this, rankList && rankList.length > 0 && rankList[0].uid)} ></div>}
                <img src={rankList && rankList.length > 0 && rankList[0].avatarurl || '/img/de_img_logo.png'} alt=""  className='two-tx'/>
              </div>
              <div className="one-info">
                <div className="name">{rankList && rankList.length > 0 && rankList[0].nickname}</div>
                <div>ID:{rankList && rankList.length > 0 && rankList[0].duid}</div>
                <div className="money-info">
                  <img src="/img/activity/national/jb.png" alt="" />
                  <div className="money">{score(rankList && rankList.length > 0 && rankList[0].value)}</div>
                </div>
              </div>
            </div>

            {/* 2,3  */}

            <div className="others-box">

              <div className="two-box">
                <div className="tx-box" onClick={jumpToUser.bind(this, rankList && rankList.length > 1 && rankList[1].uid)}>
                 {mycuntry.countryId==39 && <div  className='hav-tur'></div>}
                 {mycuntry.countryId==17 && <div  className='hav-ksa'></div>}
                 {mycuntry.countryId !=17 && mycuntry.countryId !=39 && <div  className='two-bj'></div>}
                  <img src={rankList && rankList.length > 1 && rankList[1].avatarurl || '/img/de_img_logo.png'} className="two-tx" alt="" />
                </div>
                <div className="two-info">
                  <div className="name">{rankList && rankList.length > 1 && rankList[1].nickname}</div>
                  <div>ID:{rankList && rankList.length > 1 && rankList[1].duid}</div>
                  <div className="money-info">
                    <img src="/img/activity/national/jb.png" alt="" />
                    <div className="money">{score(rankList && rankList.length > 1 && rankList[1].value)}</div>
                  </div>
                </div>
              </div>


              <div className="three-box">
                <div className="tx-box">
                {mycuntry.countryId==39 && <div  className='hav-tur'></div>}
                {mycuntry.countryId==17 && <div  className='hav-ksa'></div>}
                {mycuntry.countryId !=17 && mycuntry.countryId !=39 && <div  className='three-bj'></div>}
                  <img src={rankList && rankList.length > 2 && rankList[2].avatarurl || '/img/de_img_logo.png'} className="three-tx" alt="" />
                </div>
                <div className="three-info">
                  <div className="name">{rankList && rankList.length > 2 && rankList[2].nickname}</div>
                  <div>ID:{rankList && rankList.length > 2 && rankList[2].duid}</div>
                  <div className="money-info">
                    <img src="/img/activity/national/jb.png" alt="" />
                    <div className="money">{score(rankList && rankList.length > 2 && rankList[2].value)}</div>
                  </div>
                </div>
              </div>

            </div>

            {/* 4-10 */}
            <div className={`remain ${language == 'ar' && 'arlang'}`}>
              {rankList && rankList.length > 3 &&
                rankList
                  .filter((ele, index) => {
                    return index > 2
                  })
                  .map((item, index) => {
                    if (index <= 6) {
                      return (
                        <div className="others-rank" key={index} onClick={jumpToUser.bind(this, item.uid)}>
                          <div className="rank-num">{index + 4}</div>
                          <div className="rank-user-box">
                            <div className="rank-user">
                              <img src={item.avatarurl} alt="" />
                            </div>
                            <div className="info">
                              <div className="user-info">
                                <div className="xinxi">
                                  <div className="name">{item.nickname}</div>
                                  <div className="uid">ID:{item.duid}</div>
                                </div>
                                <div className="money">
                                  <img src="/img/activity/national/jb.png" alt="" />
                                  <div>{score(item.value)}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  })}
            </div>

            {/* 我的排名 */}
            <div className={`others-rank myrank ${language == 'ar' ? 'arlang' : ''}`}>
              <div className="rank-num">{thisMyUserRank.rank}</div>
              <div className="rank-user-box">
                <div className="rank-user" onClick={jumpToUser.bind(this, thisMyUserRank.uid)}>
                  <img src={thisMyUserRank.avatarurl} alt="" />
                </div>
                <div className="info">
                  <div className="user-info">
                    <div className="xinxi">
                      <div className="name">{thisMyUserRank.nickname}</div>
                      <div className="uid">ID:{thisMyUserRank.duid}</div>
                    </div>
                    <div className="money">
                      <img src="/img/activity/national/jb.png" alt="" />
                      <div>{score(thisMyUserRank.value)}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* LastWeek */}
        <div style={{ display: this.props.selectStateChild === '2' ? 'block' : 'none' }}>
          {/* rankings-part */}
          <div className="rank-wrap"
            style={{
              height: `${heightTotalLast()}`,
            }}
          >
            {/* title */}
            <div className="rank-title">{lang.points}</div>
            {/* 1 */}

            <div className="one-wrap">
              <div className="one-avatar">
                {mycuntry.countryId ==39 && <div className="test-tur" onClick={jumpToUser.bind(this, rankList && rankList.length > 0 && rankList[0].uid)} ></div>}
                {mycuntry.countryId ==17 && <div className="ksa" onClick={jumpToUser.bind(this, rankList && rankList.length > 0 && rankList[0].uid)} ></div>}
                {mycuntry.countryId !=17 && mycuntry.countryId !=39 && <div className="one-box" onClick={jumpToUser.bind(this, rankList && rankList.length > 0 && rankList[0].uid)} ></div>}
                <img src={lastUserRankList && lastUserRankList.length > 0 && lastUserRankList[0].avatarurl || '/img/de_img_logo.png'} alt="" className='tw-tx' />
              </div>
              <div className="one-info">
                <div className='name'>{lastUserRankList && lastUserRankList.length > 0 && lastUserRankList[0].nickname}</div>
                <div>ID:{lastUserRankList && lastUserRankList.length > 0 && lastUserRankList[0].duid}</div>
                <div className="money-info">
                  <img src="/img/activity/national/jb.png" alt="" />
                  <div className="money">{score(lastUserRankList && lastUserRankList.length > 0 && lastUserRankList[0].value)}</div>
                </div>
              </div>
            </div>

            {/* 2,3  */}

            <div className="others-box">

              <div className="two-box">
                <div className="tx-box">
                {mycuntry.countryId==39 && <div  className='hav-tur'></div>}
                {mycuntry.countryId==17 && <div  className='hav-ksa'></div>}
                {mycuntry.countryId !=17 && mycuntry.countryId !=39 && <div  className='two-bj'></div>}
                  <img src={lastUserRankList && lastUserRankList.length > 1 && lastUserRankList[1].avatarurl || '/img/de_img_logo.png'} className="two-tx" alt="" />
                </div>
                <div className="two-info">
                  <div className='name'>{lastUserRankList && lastUserRankList.length > 1 && lastUserRankList[1].nickname}</div>
                  <div>ID:{lastUserRankList && lastUserRankList.length > 1 && lastUserRankList[1].duid}</div>
                  <div className="money-info">
                    <img src="/img/activity/national/jb.png" alt="" />
                    <div className="money">{score(lastUserRankList && lastUserRankList.length > 1 && lastUserRankList[1].value)}</div>
                  </div>
                </div>
              </div>

              <div className="three-box">
                <div className="tx-box">
                {mycuntry.countryId==39 && <div  className='hav-tur'></div>}
                {mycuntry.countryId==17 && <div  className='hav-ksa'></div>}
                {mycuntry.countryId !=17 && mycuntry.countryId !=39 && <div  className='three-bj'></div>}
                  <img src={lastUserRankList && lastUserRankList.length > 2 && lastUserRankList[2].avatarurl || '/img/de_img_logo.png'} className="three-tx" alt="" />
                </div>
                <div className="three-info">
                  <div className='name'>{lastUserRankList && lastUserRankList.length > 2 && lastUserRankList[2].nickname}</div>
                  <div>ID:{lastUserRankList && lastUserRankList.length > 2 && lastUserRankList[2].duid}</div>
                  <div className="money-info">
                    <img src="/img/activity/national/jb.png" alt="" />
                    <div className="money">{score(lastUserRankList && lastUserRankList.length > 2 && lastUserRankList[2].value)}</div>
                  </div>
                </div>
              </div>

            </div>

            {/* 4-10 */}
            {lastUserRankList && lastUserRankList.length > 3 && (
              <div className={`remain ${language == 'ar' && 'arlang'}`}>
                {lastUserRankList &&
                  lastUserRankList
                    .filter((ele, index) => {
                      return index > 2
                    })
                    .map((item, index) => {
                      if (index <= 6) {
                        return (
                          <div className="others-rank" key={index} onClick={jumpToUser.bind(this, item.uid)}>
                            <div className="rank-num">{index + 4}</div>
                            <div className="rank-user-box">
                              <div className="rank-user">
                                <img src={item.avatarurl} alt="" />
                              </div>
                              <div className="info">
                                <div className="user-info">
                                  <div className="xinxi">
                                    <div className="name">{item.nickname}</div>
                                    <div className="uid">ID:{item.duid}</div>
                                  </div>
                                  <div className="money">
                                    <img src="/img/activity/national/jb.png" alt="" />
                                    <div>{score(item.value)}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    })}

              </div>
            )}

            {/* 我的排名 */}
            <div className={`others-rank myrank ${language == 'ar' ? 'arlang' : ''}`}>
              <div className="rank-num">{lastMyUserRank.rank}</div>
              <div className="rank-user-box">
                <div className="rank-user" onClick={jumpToUser.bind(this, lastMyUserRank.uid)}>
                  <img src={lastMyUserRank.avatarurl} alt="" />
                </div>
                <div className="info">
                  <div className="user-info">
                    <div className="xinxi">
                      <div className="name">{lastMyUserRank.nickname}</div>
                      <div className="uid">ID:{lastMyUserRank.duid}</div>
                    </div>
                    <div className="money">
                      <img src="/img/activity/national/jb.png" alt="" />
                      <div>{score(lastMyUserRank.value)}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national/Rank/index.js